import IMask from 'imask';

/**
 * get the current date but with the year a person with the specified age would be born
 * @param {number} age
 * @returns {Date}
 */
function getBirthYearDate(age = 0) {
  return new Date(new Date().setFullYear(new Date().getFullYear() - age));
}

const masks = {
  '.birthdayMask': {},
  '.birthdayMask16': {
    max: getBirthYearDate(16)
  },
  '.birthdayMaskEn': {
    placeholder: 'DD.MM.YYYY'
  },
  '.dateMaskNow': {
    min: getBirthYearDate(),
    max: null
  }
};

for (const [key, object] of Object.entries(masks)) {
  document.querySelectorAll(key).forEach(input => {
    initMask(input, object);
  });
}

function initMask(input, maskConfig) {
  const imask = IMask(input, {
    mask: Date,
    min: maskConfig.min ? maskConfig.min : getBirthYearDate(84),
    max: maskConfig.max ? maskConfig.max : getBirthYearDate(),
    autofix: true,
    overwrite: true,
    pattern: 'd.m.Y',
    blocks: {
      d: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2,
        placeholderChar: 'T'
      },
      m: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2,
        placeholderChar: 'M'
      },
      Y: {
        mask: IMask.MaskedRange,
        from: getBirthYearDate(84).getFullYear(),
        to: getBirthYearDate().getFullYear(),
        maxLength: 4,
        placeholderChar: 'J'
      }
    }
  });
  input.imask = imask;
  return imask;
}

window.initMask = input => {
  initMask(input, {});
};
window.dispatchEvent(new Event('initIMask'));
